import { render, staticRenderFns } from "./bindPass.vue?vue&type=template&id=e8ceb7ca&scoped=true&"
import script from "./bindPass.vue?vue&type=script&lang=js&"
export * from "./bindPass.vue?vue&type=script&lang=js&"
import style0 from "./bindPass.vue?vue&type=style&index=0&id=e8ceb7ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8ceb7ca",
  null
  
)

export default component.exports